import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-empty-property',
  templateUrl: './icon-empty-property.component.html',
  styles: []
})
export class IconEmptyPropertyComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
